// The VoltaGrid jobs: the ones that get the Overview VoltaGrid and Cost Plus
// Forecast tabs, the Revenue Budget and the editable phase descriptions. The
// same four the Billing invoice folder lists. Not the same thing as
// billingContract's MEPC_JOBS, which is the pair whose Service Order rules
// (per diem, standby) are on by default. Kept out of the component files so
// the side menu can gate on it without pulling the Overview page in.
export const VOLTAGRID_JOBS = ['54026070', '54026071', '54026076', '54026077'];

export const isVoltaGridJob = (job) => VOLTAGRID_JOBS.includes(String(job || ''));
